import { update } from "lodash";
import { sessionStorage } from "../assets/js/storage";
import router from "../router/index";
import Vue from 'vue';
const homeView  =     {
      name: "工作台",
      detail:"/home",
      componentName:'home'
    }
const mutations = {
  user_id(state, user) {
    state.user = user;
    sessionStorage.setItem("user_id", user);
  },
  token(state, token) {
    state.token = token;
    sessionStorage.setItem("token", token);
  },
  salesAuthorityId(state, salesAuthorityId) {
    state.salesAuthorityId = salesAuthorityId;
    sessionStorage.setItem("salesAuthorityId", salesAuthorityId);
  },
  setToolData(state, data) {
    // 当data.componentName等于blackList时特殊处理,state.toolBarData只能保存一个
    const blackList = ["editApproval", "editProcess"];
    const isBlack = blackList.includes(data.componentName);

    // 添加标签按钮，如果当前路由已经打开，则不再重复添加
    if (router.app.$route.meta.keepAlive) {
      if (data.name !== "工作台") {
        if (isBlack) {
          const blackIndex = state.toolBarData.findIndex((item) =>
            blackList.includes(item.componentName)
          );
          if (blackIndex >= 0) {
            state.toolBarData.splice(blackIndex, 1, { ...data });
          } else {
            state.toolBarData.push({ ...data });
          }
        } else {
          const inToolbar = state.toolBarData.find(
            (item) => item.detail === data.detail
          );
          if (!inToolbar) state.toolBarData.push({ ...data });
        }
      }
    }
    // console.log(router.app.$route.meta.keepAlive)
  },
  addOrderCount(state, count) {
    state.orderCount = count;
  },
  setCacheView(state, data) {
    // 与setToolData类似
    const blackList = ["editApproval", "editProcess"];
    const isBlack = blackList.includes(data.componentName);
    if (data.name === "工作台") return;

    if (isBlack) {
      const blackIndex = state.cacheView.findIndex((item) =>
        blackList.includes(item)
      );
      if (blackIndex >= 0) {
        state.cacheView.splice(blackIndex, 1, data.componentName);
      } else {
        state.cacheView.push(data.componentName);
      }
    } else if (!state.cacheView.includes(data.componentName)) {
      state.cacheView.push(data.componentName);
    }
  },
  clearToolItem(state, detail) {
    const index = state.toolBarData.findIndex((item) => item.detail === detail);
    const isActive =
      router.app.$route.path == state.toolBarData[index]["detail"];
    const len = state.toolBarData.length - 1;
    state.toolBarData.splice(index, 1);
    // (index == len || isActive) && router.push({path:state.toolBarData[state.toolBarData.length - 1]["detail"]});
  },
  clearCacheView(state, viewName) {
    const index = state.cacheView.findIndex((item) => item == viewName);
    state.cacheView.splice(index, 1);
  },
  clearCacheOther(state,item) {
    state.toolBarData = [homeView,item];
    state.cacheView = [homeView.componentName,item.componentName];
  },
  clearCacheAll(state) {
    state.toolBarData = [homeView];
    state.cacheView =  [homeView.componentName];
  },
  closeTar(state, e) {
    state.toolBarData = [];
    state.cacheView = [];
  },
  updateTabStorage(state, e) {
    state.tabStorage = e;
  },
  selectedNode(state, val) {
    state.selectedNode = val
  },
  loadForm(state, val){
    state.design = val
  },
  setIsEdit(state, val){
    state.isEdit = val
  },
  setEditForm(state, val){
    state.editForm = val
  },
  setDesignForm(state, val){
    state.design = val
  },
  updateBase(state, { key, value }) {
    Vue.set(state.design, key, value);
  },
  updatePro(state, { key, value }) {
    Vue.set(state.design.settings, key, value);
  },
  updateProAutoDedup(state, { key, value }) {
    Vue.set(state.design.settings.autoDeduplicationSettings, key, value);
  },
  updateProTimeLimited(state, { key, value }) {
    Vue.set(state.design.settings.timeLimitedApproval, key, value);
  },
  updateProNotice(state, { key, value }) {
    Vue.set(state.design.settings.notificationSettings, key, value);
  },
  
  updatesSelectFormItem(state, value) {
    state.selectFormItem = value
  },
  updatesDesignForms(state, value) {
    state.design.formItems = value
  },
  updateSelectedNode(state, {key,value}) {
    Vue.set(state.selectedNode.props, key, value);
  },
  updateSelectedNodeNobody(state, {key,value}) {
    Vue.set(state.selectedNode.props.nobody, key, value);
  },
  addFormItem(state, newItem) {
    state.design.formItems.push(newItem)
  },
  insertFormItem(state, {index,item}) {
    state.design.formItems.splice(index, 0, item);
  },
  removeFormItem(state, index) {
    if (index >= 0 && index < state.design.formItems.length) {
      state.design.formItems.splice(index, 1);
    }
  },
  updateReadCount(state, val){
    state.readCount = val
  },
  updateCollapsed(state, val){
    state.isCollapsed = val
  },
  // 工作台顶部栏未读数
  // updateUnreadCount(state, count) {
  //   state.unreadCount = count;
  // }
};

export default mutations;
